<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="账号">
								<a-input v-model="queryParams.account" placeholder="" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="姓名">
								<a-input v-model="queryParams.username" placeholder="" />
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :span="4">
								<a-form-item label="电话">
									<a-input v-model="queryParams.tel" placeholder="" />
								</a-form-item>
							</a-col>
							<a-col :span="4">
								<a-form-item label="邮箱">
									<a-input v-model="queryParams.mail" placeholder="" />
								</a-form-item>
							</a-col>
							<a-col :span="4">
								<a-form-item label="状态">
									<a-select v-model="queryParams.isDisabled" placeholder="请选择" default-value="">
										<a-select-option value="N">正常</a-select-option>
										<a-select-option value="Y">禁用</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="() => this.queryParams={}">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button v-has="'/system/adminAdd'" type="primary" icon="plus" @click="add">新增</a-button>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">
				<span slot="status" slot-scope="record">
					<label v-if="record.isDisabled == 'N'" class="normal">正常</label>
					<label v-else class="disabled">禁用</label>
				</span>
				
				<span slot="google" slot-scope="record">
					<label v-if="record.googleSecret" class="normal">已绑定
						<a-divider type="vertical" />	
						
						<a-popconfirm placement="topRight" title="你确定要解绑改用户吗?" @confirm="unbindGoogle(record.id)">
							<a href="#" v-has="'/system/unBindGoogle'" class="error">解绑</a>
						</a-popconfirm>
					</label>
					
					<label v-else class="disabled">未绑定</label>
				</span>

				<span slot="action" slot-scope="record">
					<template v-if="record.isDisabled == 'N'">
						<a v-has="'/system/adminResetPassword'" @click="resetPassword(record)">重置密码</a>
						<a-divider type="vertical" />
						<a v-has="'/system/adminUpdate'" @click="update(record)">修改</a>
						<a-divider type="vertical" />
						<a v-has="'/system/adminDel'" @click="setDisabled(record.id, 'Y')">禁用</a>
						<span v-if="!record.googleSecret">
							<a-divider type="vertical" />
							<a @click="bindGoogle(record.id)" v-has="'/system/googleBind'">谷歌绑定</a>
						</span>
					</template>
					<template v-else>
						<a @click="setDisabled(record.id, 'N')">启用</a>
					</template>
				</span>
			</a-table>

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>

			<admin-form-modal ref="adminForm" :visible="adminFormVisible" :loading="adminFormLoading"
				:model="adminFormModel" @cancel="adminFormCancel" @ok="adminFormOk" />

			<reset-password-modal ref="resetPasswordForm" :id="resetPasswdAdminId" :visible="resetPasswdVisible"
				:loading="resetPasswdLoading" @cancel="resetPasswdCancel" @ok="resetPasswdOk" />
		</a-card>

		<a-modal :visible="googleVisible" title="绑定谷歌验证" @cancel="closeGoogleVisible" @ok="confirmBind">
			<div class="qrcode-box">
				<img class="qrcode" width="300px" height="300px" :src="qrcode" />
			</div>
		</a-modal>
	</div>
</template>

<script>
	import AdminFormModal from './AdminForm';
	import ResetPasswordModal from './ResetPassword';
	import {
		adminList,
		adminAdd,
		adminUpdate,
		adminResetPassword,
		adminSetDisabled,
		adminBindGoogleAuth,
		adminUnBindGoogleAuth,
		adminBindGoogleAuthPro
	} from "@/api/system/admin";

	const tableColumns = [{
			title: '#',
			dataIndex: 'id'
		},
		{
			title: '账号',
			dataIndex: 'account'
		},
		{
			title: '姓名',
			dataIndex: 'username'
		},
		{
			title: '电话',
			dataIndex: 'tel'
		},
		{
			title: '邮箱',
			dataIndex: 'mail'
		},
		{
			title: '角色',
			dataIndex: 'roles'
		},
		{
			title: '状态',
			scopedSlots: {
				customRender: 'status'
			}
		},
		{
			title: '谷歌验证',
			scopedSlots: {
				customRender: 'google'
			}
		},
		{
			title: '创建时间',
			dataIndex: 'created'
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			AdminFormModal,
			ResetPasswordModal
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				tableLoading: false,
				tableColumns,
				tableData: [],
				totalRow: 0,
				pageSize: 20,
				pageIndex: 1,
				adminFormVisible: false,
				adminFormLoading: false,
				adminFormModel: null,
				resetPasswdAdminId: 0,
				resetPasswdVisible: false,
				resetPasswdLoading: false,
				googleVisible: false,
				qrcode: '',
				adminId: ''
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				return adminList(this.queryParams).then(res => {
					this.tableData = res.data.recordList;
					this.totalRow = res.data.totalRow;
					this.tableLoading = false;
				});
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			add() {
				this.adminFormModel = null;
				this.adminFormVisible = true;
				this.$nextTick(() => {
					if (this.$refs.adminForm && this.$refs.adminForm.initForm) {
						this.$refs.adminForm.initForm();
					}
				});
			},
			update(record) {
				this.adminFormVisible = true;
				this.adminFormModel = {
					...record
				}
			},
			adminFormOk() {
				const modal = this.$refs.adminForm;
				if (!modal || !modal.$refs.adminForm) {
					return;
				}
				modal.$refs.adminForm.validate((valid) => {
					if (!valid) {
						return;
					}
					const values = { ...modal.form };
					this.adminFormLoading = true;
					if (values.id > 0) {
						delete values.account;
						delete values.password;
						adminUpdate(values).then(() => {
							this.adminFormAfter('修改管理员成功');
						}).catch(() => {
							this.adminFormLoading = false;
						});
					} else {
						adminAdd(values).then(() => {
							this.adminFormAfter('新增管理员成功');
						}).catch(() => {
							this.adminFormLoading = false;
						});
					}
				});
			},
			adminFormCancel() {
				this.adminFormVisible = false;
				this.adminFormModel = null;
				if (this.$refs.adminForm && this.$refs.adminForm.initForm) {
					this.$refs.adminForm.initForm();
				}
			},
			adminFormAfter(message) {
				this.adminFormVisible = false;
				this.adminFormLoading = false;
				if (this.$refs.adminForm && this.$refs.adminForm.initForm) {
					this.$refs.adminForm.initForm();
				}
				this.fetchTableData();
				this.$message.success(message);
			},
			resetPassword(record) {
				this.resetPasswdAdminId = record.id;
				this.resetPasswdVisible = true;
			},
			resetPasswdCancel() {
				this.resetPasswdVisible = false;
			},
			resetPasswdOk() {
				const modal = this.$refs.resetPasswordForm;
				if (!modal || !modal.$refs.adminForm) {
					return;
				}
				this.resetPasswdLoading = true;
				modal.$refs.adminForm.validate((valid) => {
					if (!valid) {
						this.resetPasswdLoading = false;
						return;
					}
					const values = { ...modal.form };
					adminResetPassword(values).then(() => {
						this.resetPasswdVisible = false;
						this.resetPasswdLoading = false;
						modal.form.password = '';
						if (modal.$refs.adminForm) {
							modal.$refs.adminForm.clearValidate();
						}
						this.$message.success('重置管理员密码成功');
					}).catch(() => {
						this.resetPasswdLoading = false;
					});
				});
			},
			setDisabled(id, disable) {
				adminSetDisabled(id, disable).then(() => {
					this.fetchTableData();
					if (disable == 'Y') {
						this.$message.success(`删除管理员:${id}，已禁用`);
					} else {
						this.$message.success(`删除管理员:${id}，已启用`);
					}
				})
			},
			bindGoogle(id) {
				let that = this;
				adminBindGoogleAuth(id).then(function(res) {
					if( res.code != 200 ) {
						this.$message.success(res.message);
						return false;
					}
					that.googleVisible = true;
					that.qrcode = res.data.qrcode;
					that.secret = res.data.secret;
					that.adminId = id;
				});
			},
			unbindGoogle(id) {
				adminUnBindGoogleAuth(id).then(() => {
					this.fetchTableData();
					this.$message.success('解绑成功');
				});
			},
			confirmBind() {
				let that = this;
				let params = {'id': that.adminId, 'secret': that.secret}
				adminBindGoogleAuthPro(params).then(function() {
					that.$message.success('绑定成功');
					
					that.fetchTableData();
					that.googleVisible = false;
				});
			},
			closeGoogleVisible() {
				this.googleVisible = false;
			}
		}
	}
</script>

<style scoped>
.qrcode-box {
	.qrcode {
		display: flex;
		margin: auto;
	}
}
</style>